import React from 'react'
import { Form } from 'react-final-form'

import { Primary } from '@cinch/oxd-components/button/src'
import OmniValue from '@cinch/oxd-components/omni-value/src'
import { currencyValueFormatter } from '@cinch/oxd-utils/form/src'

import Fields, { Props as FieldsProps } from './components/fields.component'

import * as styles from './your-money.module.css'

interface YourMoneyProps extends Pick<FieldsProps, 'hideAdditionalOptions'> {
  i18n: Pick<
    Cinch.WebAppTranslations['myProfile']['money'],
    Exclude<keyof Cinch.WebAppTranslations['myProfile']['money'], 'title' | 'subtitle'>
  >
  onSubmit: (values: any) => any
  initialValues?: Partial<Cinch.IMoneyFormData>
  buttonSize?: 'mini' | 'regular' | 'large'
  compact?: boolean
}

const YourMoney: React.FC<YourMoneyProps> = ({
  i18n,
  onSubmit,
  initialValues = {},
  buttonSize,
  compact = false,
  ...fieldsProps
}) => {
  const { cash, partEx, finance, submit, budgetLabel } = i18n

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, pristine, values }) => (
        <>
          {!compact && <OmniValue value={currencyValueFormatter(values.budget)} label={budgetLabel} />}
          <form onSubmit={handleSubmit}>
            <Fields
              valueFormatter={() => currencyValueFormatter(values.budget)}
              i18n={{ cash, partEx, finance }}
              {...fieldsProps}
            />
            <Primary
              oxdClassName={styles.submit}
              type="submit"
              size={buttonSize || 'regular'}
              disabled={pristine}
              oxford={true}
            >
              {submit}
            </Primary>
          </form>
        </>
      )}
    />
  )
}

export default YourMoney
